import { createSelector } from 'reselect';
import { getOffline } from './getOffline';
import { getUnavailableStartAt } from './getUnavailableStartAt';
import { getFaultStartAt } from './getFaultStartAt';
import { getConnection } from './getConnection';
import { getStatusStartAt } from './getStatusStartAt';
import { getFAICurrentInspectionElapsedSince } from './getFAICurrentInspectionElapsedSince';

export const getMachineHeaderTime = createSelector(
  [
    getOffline,
    getUnavailableStartAt,
    getFaultStartAt,
    getConnection,
    getStatusStartAt,
    getFAICurrentInspectionElapsedSince,
  ],
  (
    offline,
    unavailableStartAt,
    faultStartAt,
    { disconnectedAt },
    statusStartAt,
    faiElapsedSince
  ) => {
    return (
      (offline && disconnectedAt) ||
      unavailableStartAt ||
      faultStartAt ||
      faiElapsedSince ||
      statusStartAt
    );
  }
);
